var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.6 992h608v-163.2h156.8V32H129.6z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.6 859.2h-112v112l0.016-0.016z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6 0v1024h665.6l163.2-163.2V0H97.6z m672 971.2v-112h112l-112 112z m124.8-142.4h-156.8V992h-608V32h764.8v796.8z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2 152h536v32h-536zM243.2 264h536v32h-536zM243.2 376h536v32h-536zM243.2 488h536v32h-536zM243.2 600h536v32h-536zM243.2 712h536v32h-536z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredDocument);
export default __webpack_public_path__ + "static/media/ColoredDocument.57d57f2034427e97050550ef80a34e0d.svg";
export { ForwardRef as ReactComponent };